import { useModals } from 'almanac-ui/Modal'
import { Button } from 'components/Button'
import { LargeCardWithButtons } from 'components/SecretIdentityModal/LargeCardWithButtons'
import { SecretIdentityModal } from 'components/SecretIdentityModal/SecretIdentityModal'
import { Underlay } from 'components/SecretIdentityModal/Underlay/Underlay'
import { useCurrentUserProfile } from 'hooks/queries/users/useCurrentUserProfile'
import styles from './SecretIdentity.module.scss'

export const SecretIdentity = () => {
  const profile = useCurrentUserProfile()
  const { openModal } = useModals()

  if (!profile.data) return null

  const secretIdentity = profile.data.secret_identity

  if (!('identity_key' in secretIdentity)) {
    return (
      <div className={styles.buttonContainer}>
        <Button variant="secondary" onPress={() => openModal(SecretIdentityModal)} size="lg">
          Choose your secret identity
        </Button>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Underlay fill={secretIdentity.background_color} centered>
        <div className={styles.cardContainer}>
          <LargeCardWithButtons secretIdentity={secretIdentity} />
        </div>
      </Underlay>
    </div>
  )
}
